import React from 'react';
import Svg, { G, Path } from 'react-native-svg';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const HomeBrokenIcon: React.FC<IconProps> = ({
  width = 25,
  height = 24,
  color = '#ACB5D1',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 25 24" fill="none">
      <G id="Home">
        <Path
          id="Vector"
          d="M9.5 16C10.3504 16.6303 11.3846 17 12.5 17C13.6154 17 14.6496 16.6303 15.5 16"
          stroke={color}
          strokeWidth={1.5}
          strokeLinecap="round"
        />
        <Path
          id="Vector_2"
          d="M22.5 12.2039V13.725C22.5 17.6258 22.5 19.5763 21.3284 20.7881C20.1569 22 18.2712 22 14.5 22H10.5C6.72876 22 4.84315 22 3.67157 20.7881C2.5 19.5763 2.5 17.6258 2.5 13.725V12.2039C2.5 9.91549 2.5 8.77128 3.0192 7.82274C3.5384 6.87421 4.48695 6.28551 6.38403 5.10813L8.38403 3.86687C10.3894 2.62229 11.3921 2 12.5 2C13.6079 2 14.6106 2.62229 16.616 3.86687L18.616 5.10812C20.5131 6.28551 21.4616 6.87421 21.9808 7.82274"
          stroke={color}
          strokeWidth={1.5}
          strokeLinecap="round"
        />
      </G>
    </Svg>
  );
};

export default HomeBrokenIcon;
